import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';

import { useDebounce } from './useDebounce';

export const useSearch = (
  onSearchRequest: (value: string) => void,
): [string, (newValue: string) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [search, setSearch] = useState<string>(
    () => searchParams.get('search') || '',
  );

  const debouncedSearchValue = useDebounce<string>(search);

  const updateParams = (value: string): void => {
    if (!value) {
      searchParams.delete('search');
      setSearchParams(searchParams);
      return;
    }
    searchParams.set('search', value);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    updateParams(debouncedSearchValue);
    onSearchRequest(debouncedSearchValue);
  }, [debouncedSearchValue]);

  return [search, setSearch];
};
